export const initDataUsuarioRimac = {
  serie: "",
  serieNumberFrom: "",
  serieNumberUntil: "",
  ticketType: "",
  initDate: new Date(),
  endDate: new Date(),
  documentType: "",
  documentNumber: "",
  businessName: "",
  sunatStatus: "",
  company: "",
};

export const initDataProveedorRimac = {
  serie: "",
  serieNumberFrom: "",
  serieNumberUntil: "",
  ticketType: "",
  initDate: new Date(),
  endDate: new Date(),
  sunatStatus: "",
  company: "",
};
export const initDataProveedor = {
  idpTipoDocumento: "",
  numDocumento: "",
  nombreRazonSocial: "",
  nombreComercial: "",
  correoNotificacion: ""
};
export const initDataProveedorDB = {
  idpClasificacion: "",
  idpCiiu: "",
  descCiiu: "",
  aniosExperiencia: "",
  indDomiciliado: "",
  idPais: "",
  idDepartamento:"",
  idProvincia:"",
  idDistrito: "",
  direccion: "",
  refDireccion: "",
  indProteccionDatos: "",
  indLocalPrincipal:"",
  idProveedor:"",
  paginaWeb: "",
  telefono: "",
  idpBienServicio: "",
  descBienServicio: "",
  rubro: "",
  idpFrecuencia: "",
  idpMonedaBienServicio:"",
  importeBienServicio: "",
  idpTipoImporte:"",
  indAccionista:"",
  indGrupoEconomico:"",
  idpEstadoInvestigacion:"",
  aniosSentencia:""
};
export const initDataProveedorUbicacion_Ex = {
  idpClasificacion: "",
  idpCiiu: "",
  descCiiu:"",
  aniosExperiencia: "",
  indDomiciliado: "",
  idPais: "",
  idDepartamento:"",
  idProvincia:"",
  idDistrito: "",
  direccion: "",
  refDireccion: "",
  indProteccionDatos: "",
  indLocalPrincipal: "",
  idProveedor:""
};
export const initDataProveedorUbicacion_Val = {
  idpClasificacion: "",
  idpCiiu: "",
  aniosExperiencia: "",
  indDomiciliado: "",
  idPais: "",
  idDepartamento:"",
  idProvincia:"",
  idDistrito: "",
  direccion: "",
  indProteccionDatos: "",
  indLocalPrincipal: ""
};
export const initDataProveedorContacto_Val = {
  telefono: "",
  medioContacto: []
};
export const initDataProveedorContactoMedContacto_Val = {
  nombres: "",
  apePaterno: "",
  celular: "",
  correo: ""
};
export const initDataProveedorContacto_Ex = {
  paginaWeb: "",
  telefono: "",
  medioContacto: []
};
export const initDataProveedorContactoMedContacto_Ex = {
  idMedioContacto: "",
  idpTipoContacto: "",
  nombres: "",
  apePaterno: "",
  apeMaterno: "",
  celular: "",
  correo: "",
  idProveedor: ""
};
export const initDataProveedorFormaPago_Ex = {
  idpBienServicio: "",
  descBienServicio: "",
  rubro: "",
  idpFrecuencia: "",
  idpMonedaBienServicio:"",
  importeBienServicio: "",
  idpTipoImporte:"",
  formaPago: []
};
export const initDataProveedorFormaPagoArray_Ex = {
  idFormaPago: "",
  idProveedor: "",
  idpBanco: "",
  idpMoneda: "",
  numCuenta: "",
  idpTipoCuenta: "",
  nombreOtroBanco: ""
};
export const initDataProveedorFormaPago_Val = {
  idpBienServicio: "",
  descBienServicio: "",
  rubro: "",
  idpFrecuencia: "",
  importeBienServicio: "",
  idpMonedaBienServicio:"",
  idpTipoImporte:"",
  formaPago: []
};
export const initDataProveedorFormaPagoArray_Val = {
  idpBanco: "",
  idpMoneda: "",
  numCuenta: "",
  idpTipoCuenta: ""
};
export const initDataProveedorContactoMedContactoDB = {
  idMedioContacto: "",
  idpTipoContacto: "",
  nombres: "",
  apePaterno: "",
  apeMaterno: "",
  celular: "",
  correo: "", 
  numRuc: "",
  razonSocial: "",
  idpArea: "",
  idProveedor: ""
};
export const initDataProveedorReferencia_Val = {  
  referencia: []
};
export const initDataProveedorReferenciaArray_Val = {
  nombres: "",
  apePaterno: ""
};
export const initDataProveedorReferencia_Ex = {
  referencia: []
};
export const initDataProveedorReferenciaArray_Ex = {
  idMedioContacto: "",
  idpTipoContacto: "",
  nombres: "",
  apePaterno: "",
  apeMaterno: "",
  celular: "",
  correo: "",
  numRuc: "",
  razonSocial: "",
  idProveedor: ""
};
export const initDataProveedorContactoRimac_Val = {
  contactoRimac: []
};
export const initDataProveedorContactoRimacArray_Val = {  
  nombres: "",
  apePaterno: "",
  idpArea: ""
};
export const initDataProveedorContactoRimac_Ex = {  
  contactoRimac: []
};
export const initDataProveedorContactoRimacArray_Ex = {
  idMedioContacto: "",
  idpTipoContacto: "",
  nombres: "",
  apePaterno: "",
  apeMaterno: "",
  idpArea: "",
  idProveedor: ""
};
export const initDataProveedorTerceroDB = {
  idProveedorTercero: "",
  idProveedor: "",
  idpTipoTercero: "",
  idpTipoDocumento: "",
  numeroDocumento: "",
  nombres: "",
  indPep: "",
  cargo: "",
  prcCapital: "",
  aniosCargo: "",
  idPais: "",      
  fecNacimiento: "",
  profesion: "",
  direccion: "",
  telefono: "",
  correo: "",
      idpEstado: "",
      aniosSentencia: "",
      caracteristicas: "",
      indAntecedentes: "",
      indUif: "",
      indLaft: ""
};
export const initDataProveedorAccionista_Ex = {
  indAccionista:"",
  accionista: []
};
export const initDataProveedorAccionistaArray_Ex = {
  idProveedorTercero: "",
  idProveedor: "",
  idpTipoTercero: "",
  idpTipoDocumento: "",
  numeroDocumento: "",
  nombres: "",
  indPep: "",
  cargo: "",
  prcCapital: "",
  aniosCargo: "",
  idPais: "",
  idResPais: "",      
  fecNacimiento: "",
  profesion: "",
  direccion: "",
  telefono: "",
  correo: "",
  idpEstado: "",
  aniosSentencia: ""
};
export const initDataProveedorAccionista_Val = {
  indAccionista:"",
  accionista: []
};
export const initDataProveedorAccionistaArray_Val = {  
  idpTipoDocumento: "",
  numeroDocumento: "",
  nombres: "",
  indPep: "",
  cargo: "",
  prcCapital: "",
  aniosCargo: "",
  idPais: "",
  idResPais: "",      
  fecNacimiento: "",
  profesion: "",
  direccion: "",
  telefono: "",
  correo: ""
};
export const initDataProveedorRepresentante_Ex = {
  representante: []
};
export const initDataProveedorRepresentanteArray_Ex = {
  idProveedorTercero: "",
  idProveedor: "",
  idpTipoTercero: "",
  idpTipoDocumento: "",
  numeroDocumento: "",
  nombres: "",
  indPep: "",
  cargo: "",
  //prcCapital: "",
  aniosCargo: "",
  idPais: "",
  idResPais: "",      
  fecNacimiento: "",
  profesion: "",
  direccion: "",
  telefono: "",
  correo: "",
  idpEstado: "",
  aniosSentencia: ""
};
export const initDataProveedorRepresentante_Val = {
  representante: []
};
export const initDataProveedorRepresentanteArray_Val = {  
  idpTipoDocumento: "",
  numeroDocumento: "",
  nombres: "",
  indPep: "",
  cargo: "",
  //prcCapital: "",
  aniosCargo: "",
  idPais: "",
  idResPais: "",      
  fecNacimiento: "",
  profesion: "",
  direccion: "",
  telefono: "",
  correo: ""
};
export const initDataProveedorGrupoEconomico_Ex = {
  grupoEconomico: []
};
export const initDataProveedorGrupoEconomicoArray_Ex = {
  idProveedorTercero: "",
  idProveedor: "",
  idpTipoTercero: "",
  idpTipoDocumento: "",
  numeroDocumento: "",
  nombres: "",  
  idPais: "",
  idpEstado: "",
  aniosSentencia: ""
};
export const initDataProveedorGrupoEconomico_Val = {
  grupoEconomico: []
};
export const initDataProveedorGrupoEconomicoArray_Val = { 
  idpTipoDocumento: "",
  numeroDocumento: "",
  nombres: "", 
  idPais: ""
};
export const initDataProveedorTransparencia_Val = {
  preguntast: [],
  listaCuadro: []
};
export const initDataProveedorTransparencia_Ex = {  
  preguntast: [],
  listaCuadro: []
};
export const initDataProveedorTransparenciaPreguntast_Val = {
  idpPregunta:'',
  indRespuesta:'',
  idpTipoPregunta:''
};
export const initDataProveedorTransparencialistaCuadro_Val = {
  idpEstado:'',
  aniosSentencia:''
};
export const initDataProveedorPreguntas_Val = {
  preguntas: []
};
export const initDataProveedorPreguntas_Ex = {  
  preguntas: []
};
export const initDataProveedorPreguntasArray_Val = {
  idpPregunta:'',
  indRespuesta:'',
  idpTipoPregunta:'',
  comentario: ''
};
export const initReporteFacturaRimac = {
  anio: "",
  mes: "",
  compania: "",
  tipoDocumento: "",
  idearea: ""
};

export const initReporteRegCompras = {
  anio: "",
  mes: "",
  compania: "",
  area: ""
};

export const initUser = {
  fullname: "",
  email: "",
  profile: "",
  status: "",
};

export const initArea = {
  name: "",
  email: "",
  emailRecepcion: "",
  estado: null,
};

export const initReporte = {
  anio: "",
  mes: "",
  compania: "",
  tipoDocumento: ""
};

export const typeTicketOptions = [
  { value: '01', text: "FACTURA" },
  { value: '02', text: "RECIBO X HONORARIO" },
  { value: '03', text: "BOLETA" },
  { value: '07', text: "NOTA DE CRÉDITO" },
  { value: '30', text: "DOC. AUT. BANCOS" },
  { value: '42', text: "DOC. AUT. MED. PAGO" },
  // { value: 3, text: "NOTA DE CREDITO" },
  // { value: 4, text: "NOTA DE DEBITO" },
  // { value: 5, text: "RETENCIONES" },
];
export const clasifEmpresaOptions = [
  { value: '01', text: "Persona Natural con RUC" },
  { value: '02', text: "Microempresa (Hasta 150 UIT Anual)" },
  { value: '03', text: "Pequeña Empresa ( Hasta 1,700 UIT Anual)" },
  { value: '04', text: "Mediana Empresa (Hasta 2.300 UIT Anual)" },
  { value: '05', text: "Gran Empresa de 2,300 UIT Anual)" }
];
export const typeDocumentOptions = [
  { value: 1, text: "DNI" },
  { value: 2, text: "RUC" },
  { value: 3, text: "CARNET DE EXTRANJERIA" },
  { value: 4, text: "PASAPORTE" },
  { value: 5, text: "NO DOMICILIADO" },
];

// export const sunatStatusOptions = [
//   { value: 1, text: "TODOS" },
//   { value: 2, text: "ACEPTADO" },
//   { value: 3, text: "OBSERVADO POR OSE" },
//   { value: 4, text: "RECHAZADO" },
//   { value: 5, text: "PENDIENTE DE ENVIO" },
//   { value: 6, text: "ACEPTADO CON OBSERVACIONES" },
// ];
export const sunatStatusOptions = [
  { value: 1, text: "RECHAZADO" },
  { value: 2, text: "ACEPTADO" },
  { value: 3, text: "PENDIENTE" },
];
export const companyOptions = [
  { value: 'RS', text: "RIMAC SEGUROS Y REASEGUROS" },
  { value: 'EPS', text: "EPS" },
];
export const areaRGOptions = [
  { value: "BANCA SEGUROS Y ALIANZAS", text: "BANCA SEGUROS Y ALIANZAS" },
  { value: "CENTRO DE ATENCION AL CLIENTE", text: "CENTRO DE ATENCION AL CLIENTE" },
  { value: "COASEGUROS", text: "COASEGUROS" },
  { value: "COMISIONES", text: "COMISIONES" },
  { value: "REASEGURO FACULTATIVO", text: "REASEGURO FACULTATIVO" },
  { value: "REASEGUROS CONTRATOS", text: "REASEGUROS CONTRATOS" },
  { value: "RIESGOS PATRIMONIALES", text: "RIESGOS PATRIMONIALES" },
  { value: "SALUD", text: "SALUD" },
  { value: "SINIESTROS VEHICULARES", text: "SINIESTROS VEHICULARES" },
  { value: "VENTANILLA UNICA", text: "VENTANILLA UNICA" },
  { value: "OTRO", text: "OTRO" }
];
export const formaPagoOptions = [
  { value: 'CRED', text: "CRÉDITO" },
  { value: 'CONT', text: "CONTADO" },
];
export const estadoOptions = [
  {value: 'PND', text: "PENDIENTE"},
  { value: 'REG', text: "REGISTRADO" },
  { value: 'REC', text: "RECHAZADO" },
  {value: 'ACE', text: "ACEPTADO"}  
];
export const estadoCargaOptions = [
  { value: 'PEN', text: "PENDIENTE" },
  { value: 'PRO', text: "EN PROCESO" },
  {value: 'FIN', text: "FINALIZADO"},
  {value: 'ERR', text: "CON ERROR"},
  {value: 'ACT', text: "POR ACTUALIZAR"}
];
export const accionOptions = {
  PND: [{ value: 'CON', text: "CONFORME"},
        { value: 'DIS', text: "DISCONFORME"}],
  PNR: [{ value: 'CON', text: "CONFORME"},
        { value: 'DIS', text: "DISCONFORME"}],
  SUB: [{ value: 'ACE', text: "ACEPTAR"},
        { value: 'NAC', text: "NO ACEPTAR"}]    
};
export const accionDisconformidad = 'DIS';
export const accionAceptar = 'ACE';
export const accionNoAceptar = 'NAC';
export const motivoOptions = [
  { value: '1', text: "Plazo de pago acordado" },
  { value: '2', text: "Monto neto pendiente de pago" },
  { value: '3', text: "Bienes adquiridos o servicios prestados"}
];
export const motivorimacOptions = [
  { value: '1', text: "Proveedor no registrado en los sistemas de Rimac." },
  { value: '2', text: "Proveedor no ha emitido CPE a Rimac durante los ultimos 12 meses." },
  { value: '3', text: "CPE no enviados en el plazo establecido a Rimac."}
];
export const pagoStatusOptions = [
  { value: 1, text: "PENDIENTE" },
  { value: 2, text: "PAGADA" },
  { value: 3, text: "RECHAZADA"},

];
export const areaOptions = [
  { value: 1, text: "AREA 1" },
  { value: 2, text: "AREA 2" }
];



export const profileUsers = [
  { value: 1, text: "ADMIN" },
  { value: 2, text: "CONSULTA" },
  { value: 3, text: "CARGA" },
];

export const statusUsers = [
  { value: 1, text: "ACTIVO" },
  { value: 0, text: "INACTIVO" },
];
export const typeUsers = [
  { value: 1, text: "INTERNO"  },
  { value: 2, text: "PROVEEDOR" },
];
export const monthsOptions = [
  { value: '01', text: "ENERO" },
  { value: '02', text: "FEBRERO" },
  { value: '03', text: "MARZO" },
  { value: '04', text: "ABRIL" },
  { value: '05', text: "MAYO" },
  { value: '06', text: "JUNIO" },
  { value: '07', text: "JULIO" },
  { value: '08', text: "AGOSTO" },
  { value: '09', text: "SETIEMBRE" },
  { value: '10', text: "OCTUBRE" },
  { value: '11', text: "NOVIEMBRE" },
  { value: '12', text: "DICIEMBRE" },
];

export const moneyCodes = [
  { value: 'SOL', text: "SOL"},
  { value: 'USD', text: 'USD'}
];

export const typeDocumentOptionsFiltersDP = [
  { value: 'RUC', text: "RUC" },
  { value: 'PN', text: "P. NATURAL" },
  { value: 'PJ', text: "P. JURIDICA" }
];
